/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_TitleInputs */

const en_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice Hub`)
};

const es_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de práctica`)
};

const de_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungszentrum`)
};

const zh_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习中心`)
};

const ar_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز التدريب`)
};

const fr_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de pratique`)
};

const vi_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung tâm luyện tập`)
};

const sw_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitovu cha Mazoezi`)
};

const th_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ศูนย์ฝึกซ้อม`)
};

const bs_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centar za vježbanje`)
};

const ja_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習センター`)
};

const ko_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습 센터`)
};

const pt_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central de prática`)
};

const it_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di allenamento`)
};

const sv_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träningscenter`)
};

const nl_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefencentrum`)
};

const da_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træningscenter`)
};

const nb_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningssenter`)
};

const fi_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskeskus`)
};

const pl_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum treningowe`)
};

const ru_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренировочный центр`)
};

const tr_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman Merkezi`)
};

const hi_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास केंद्र`)
};

const id_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Latihan`)
};

const ms_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab Latihan`)
};

const cs_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tréninkové centrum`)
};

const el_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κέντρο εξάσκησης`)
};

const he_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרכז תרגול`)
};

const af_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefensentrum`)
};

const hu_practice_title = /** @type {(inputs: Practice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlóközpont`)
};

/**
* | output |
* | --- |
* | "Practice Hub" |
*
* @param {Practice_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_title = /** @type {((inputs?: Practice_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_title(inputs)
	if (locale === "de") return de_practice_title(inputs)
	if (locale === "zh") return zh_practice_title(inputs)
	if (locale === "ar") return ar_practice_title(inputs)
	if (locale === "fr") return fr_practice_title(inputs)
	if (locale === "vi") return vi_practice_title(inputs)
	if (locale === "sw") return sw_practice_title(inputs)
	if (locale === "th") return th_practice_title(inputs)
	if (locale === "bs") return bs_practice_title(inputs)
	if (locale === "ja") return ja_practice_title(inputs)
	if (locale === "ko") return ko_practice_title(inputs)
	if (locale === "pt") return pt_practice_title(inputs)
	if (locale === "it") return it_practice_title(inputs)
	if (locale === "sv") return sv_practice_title(inputs)
	if (locale === "nl") return nl_practice_title(inputs)
	if (locale === "da") return da_practice_title(inputs)
	if (locale === "nb") return nb_practice_title(inputs)
	if (locale === "fi") return fi_practice_title(inputs)
	if (locale === "pl") return pl_practice_title(inputs)
	if (locale === "ru") return ru_practice_title(inputs)
	if (locale === "tr") return tr_practice_title(inputs)
	if (locale === "hi") return hi_practice_title(inputs)
	if (locale === "id") return id_practice_title(inputs)
	if (locale === "ms") return ms_practice_title(inputs)
	if (locale === "cs") return cs_practice_title(inputs)
	if (locale === "el") return el_practice_title(inputs)
	if (locale === "he") return he_practice_title(inputs)
	if (locale === "af") return af_practice_title(inputs)
	if (locale === "hu") return hu_practice_title(inputs)
	return en_practice_title(inputs)
});